import React from "react";

export default function withMatchMedia(
  query,
  outputPropName = "mediaQueryMatches"
) {
  return function(Component) {
    return class ComponentWithMatchMedia extends React.Component {
      state = {
        matches: window.matchMedia(query).matches
      };

      componentDidMount() {
        this.mql = window.matchMedia(query);
        this.mql.addListener(this.handleMediaEvent);
      }

      componentWillUnmount() {
        this.mql.removeListener(this.handleMediaEvent);
      }

      handleMediaEvent = mql => {
        const matches = mql.matches;
        this.setState({
          matches
        });
      };

      render() {
        const matchProps = {
          [outputPropName]: this.state.matches
        };

        return <Component {...matchProps} {...this.props} />;
      }
    };
  };
}
